import { getStringSimilarity } from './getStringSimilarity';

// List of 20K common passwords from django (https://gist.github.com/roycewilliams/226886fd01572964e1431ac8afc999ce)
// pre-filtered to keep only those that match the following criteria:
// At least 10 characters long, Contains at least 1 special character, Contains at least 1 digit, NOT all numeric
const FILTERED_COMMON_PASSWORDS = [
  'pe#5gz29ptzmse',
  'n8zgt5p0shw=',
  'ka_djkhjsy6',
  '0.00000000',
  '1234567890-',
  'fu7u4a#$$$',
  'john!20130605at1753',
  'mega_pizdetz666',
  '123456789.',
  'feder_1941',
  'doomsayer.2.7mords.v',
  'doomsayer.2.7mords.vv',
  '1234567890-=',
  '123456789*',
  'asdfghjkl:&#39:',
  '123456789+',
  'password1!',
  'fxzz75$yer',
  'iloveyou<3',
  '"1,00001e+14"',
  'aug!272010',
  'jarox1301!',
];

const getPasswordChecks = (password = '', userAttributes = {}) => {
  // Parse all user attributes provided and check if there is at least one
  // that is too similar (>0.7 matches ratio) to the password
  const passwordTooSimilar = Object.values(userAttributes)
    .map(attribute => getStringSimilarity(attribute?.toLowerCase() ?? '', password.toLowerCase()))
    .some(similarity => similarity > 0.7);

  // Matches the exact special characters allowed by django-advanced-password-validation.
  // Better than /[^a-zA-Z0-9]/ which incorrectly flags other alphabet letters as special chars.
  const hasSpecialChar = /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(password);

  const rules = {
    atLeast10Chars: password.length >= 10,
    atLeast1Number: /\d/.test(password),
    atLeast1SpecialChar: hasSpecialChar,
    passwordIsNotSimilar: !passwordTooSimilar,
    passwordIsUncommon: !FILTERED_COMMON_PASSWORDS.includes(password),
  };

  const isAllValid = Object.values(rules).every(isValid => isValid);

  return { ...rules, isAllValid };
};

export default getPasswordChecks;
